// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qUYag{display:-webkit-box;display:flex;gap:.25rem;-webkit-box-pack:center;font-size:.875rem;justify-content:center;white-space:nowrap}.qUYag,.E8e8S{-webkit-box-align:center;align-items:center;color:#202626;font-family:Inter,sans-serif;font-weight:400;letter-spacing:0;line-height:1.35}.E8e8S{font-size:.75rem;font-weight:600;--color:#2c0b47;background-color:#0af5a7;border-radius:.1875rem;padding:.25rem}.MtWwU,.W7KQL{background:#fff;border-radius:.25rem;color:#202626;font-family:Inter,sans-serif;font-size:.75rem;font-weight:400;font-weight:600;letter-spacing:0;line-height:1.35;padding:.25rem .75rem}.EKbcw{display:-webkit-box;display:flex}.zJseB{color:#2c0b47}.yJSYP,.HD6HM{border-radius:62.5rem;height:5px;width:5px}.yJSYP{background:#22b6e7}.HD6HM{background:#bac7cc}.hXIgU{color:#bac7cc}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `qUYag`,
	"root_instabook": `E8e8S`,
	"root_motivator-high": `MtWwU`,
	"root_motivator-limited": `W7KQL`,
	"icon": `EKbcw`,
	"icon_instabook": `zJseB`,
	"icon_motivator-high": `yJSYP`,
	"icon_motivator-limited": `HD6HM`,
	"icon_previewMode": `hXIgU`
};
module.exports = ___CSS_LOADER_EXPORT___;
